import { render, staticRenderFns } from "./PatentSearchBar.vue?vue&type=template&id=30d15976&scoped=true"
import script from "./PatentSearchBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatentSearchBar.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d15976",
  null
  
)

export default component.exports